export default "__VITE_ASSET__3b02d150__"